import appMenu from './appMenu';
import { NavItemType } from 'types';

// ==============================|| MENU ITEMS ||============================== //

const menuItems: { items: NavItemType[] } = {
	items: [appMenu],
};

export default menuItems;
